import axios from 'axios';

export const authService = {
    /** Domains */

    getDomainsService: (params) => axios.get(`/goalDomain`, { auth: true, params: { ...params } }),

    createDomainService: (body) => axios.post(`/goalDomain`, body, { auth: true }),

    editDomainService: (id, body) => axios.post(`/goalDomain/${id}`, body, { auth: true }),

    deleteDomainService: (id) => axios.delete(`/goalDomain/${id}`, { auth: true }),

    /** End */
};
